// extracted by mini-css-extract-plugin
export default {"wrong":"fqJ4sZZW-XDE7q2apH31b0xiIXTCG7upq4x0J4aINzX"};